import { render, staticRenderFns } from "./HistoryRow_edited.vue?vue&type=template&id=67874ac4"
import script from "./HistoryRow_edited.vue?vue&type=script&lang=js"
export * from "./HistoryRow_edited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports